<template>
    <div v-if="bestaetigungen">
        <div class="printBtn">
            <v-btn fab @click="downloadPDF()" color="primary">
                <v-icon>mdi-download</v-icon>
            </v-btn>
        </div>
        <div class="text-center pt-1">
            <div id="printArea-antiDoping" class="d-inline-block">
                <div class="cardContainer elevation-2 mt-3">
                    <div class="cardContent">
                        <table>
                            <tr>
                                <td><img src="@/assets/oeskb.png" width="100"/></td>
                                <td class="pageHeader">
                                    <div>ÖSTERREICHISCHER SPORTKEGEL- und BOWLINGVERBAND</div>
                                    <div>Mitglied World Bowling</div>
                                </td>
                            </tr>
                        </table>
                        <div style="margin-bottom: 8px; margin-top: 24px">An den Verein</div>
                        <div class="vereinsName">{{vereinsName}}</div><div style="float: right">Wien, {{todayString}}</div>
                        <div class="bestHeader">BESTÄTIGUNG
                            <span v-if="bestaetigungen.seiten>1">(Seite {{aktuelleSeite}}/{{bestaetigungen.seiten}})</span>
                        </div>
                        <div>Nachstehend angeführte SpielerInnen haben die Anti-Doping-Erklärungen für das Sportjahr
                            {{$store.state.local.sportJahr.current.text}}
                            abgegeben und sind für euren Verein bei den Österreichischen Staatmeisterschaften und
                            Österreichischen Meisterschaften startberechtigt, ein Ärztliches Attest mit
                            nachstehendem Gültigkeitsdatum liegt im OESKB bzw. in den Landesverbänden auf.
                        </div>
                        <table style="margin-top: 8px">
                            <tr>
                                <th class="headerCell">NACHNAME</th>
                                <th class="headerCell">VORNAME</th>
                                <th class="headerCell">PassNr.</th>
                                <th class="headerCell" style="max-width: 16mm;">Alters-klasse</th>
                                <th class="headerCell">DSV</th>
                                <th class="headerCell">ADE</th>
                                <th class="headerCell" style="min-width: 24mm; max-width: 24mm">ÄRZTL. ATTEST gültig bis</th>
                            </tr>
                            <tr v-for="(spieler, i) in bestaetigungen.getSpielerProSeite(aktuelleSeite)" :key="i">
                                <td class="contentCell" style="min-width: 36mm;max-width: 48mm">{{ spieler.nachname }}</td>
                                <td class="contentCell" style="min-width: 36mm;max-width: 48mm">{{ spieler.vorname }}</td>
                                <td class="contentCell">{{ spieler.passNr }}</td>
                                <td class="contentCell" style="max-width: 18mm;">{{ spieler.ak }}</td>
                                <td class="contentCell">{{ spieler.dsv }}</td>
                                <td class="contentCell">{{ spieler.ade }}</td>
                                <td class="contentCell" style="min-width: 24mm; max-width: 24mm">{{ spieler.attest }}</td>
                            </tr>
                        </table>
                        <div style="color: red; margin-top: 16px">
                            Änderungen / neue DSV, ADE und Ärztl. Atteste sind dem zuständigen Passreferenten des jeweiligen Landesverbandes zu melden.
                        </div>
                        <div class="footer">
                            <table style="width: 100%; line-height: 1.2; border-top: solid 1px black">
                                <tr>
                                    <td style="width: 30%; text-align: left">
                                        <div>Anschrift: Huglgasse 13-15/2/2/6</div>
                                        <div>A – 1150 Wien (Austria)</div>
                                    </td>
                                    <td style="width: 40%; text-align: center">
                                        <div>E-Mail: office@oeskb-kegeln-bowling.at</div>
                                        <div>Website: www.oeskb.at</div>
                                    </td>
                                    <td style="width: 30%; text-align: right">
                                        <div>Telefon: 0043 (0) 1 982 1802</div>
                                        <div>Mobil: 0043 (0) 660 598 27 21</div>
                                    </td>
                                </tr>
                            </table>
                            <table style="width: 100%">
                                <tr style="font-size: 9px; font-weight: bold">
                                    <td style="text-align: left; width: 15%">ZVR-Zahl: 824397373</td>
                                    <td style="text-align: center; width: 30%">Bankverbindung: BAWAG Wien</td>
                                    <td style="text-align: center; width: 15%">BLZ: 14000</td>
                                    <td style="text-align: center; width: 15%;">BIC: BAWAATWW</td>
                                    <td style="text-align: right; width: 25%;">IBAN: AT21 1400 0040 1060 0974</td>
                                </tr>
                            </table>
                            <table style="width: 100%">
                                <tr class="text-center">
                                    <td style="text-align: left; width: 19%">
                                        <img src="@/assets/Puma.png" width="80%"/>
                                    </td>
                                    <td style="text-align: center; width: 27%">
                                        <img src="@/assets/bso.svg" width="90%"/>
                                    </td>
                                    <td style="text-align: center; width: 27%">
                                        <img src="@/assets/Sport_Austria.png" width="90%"/>
                                    </td>
                                    <td style="text-align: right; width: 27%;">
                                        <img src="@/assets/Ministerium.png" width="90%"/>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import html2pdf from "html2pdf.js/src";
import TimeStamp from "@/services/timeStamp";
export default {
    name: "bestaetigungen-pdf-inhalt",
    props: ['bestaetigungen', 'aktuelleSeite'],
    computed: {
        vereinsName(){ return this.bestaetigungen.getVereinsNameById() },
        todayString(){ return TimeStamp.getTodayString()},
    },
    methods: {
        async downloadPDF(){
            const element = document.getElementById("printArea-antiDoping")
            const opt = { margin: 0,
                filename: 'AntiDoping_' + TimeStamp.getTodayString() + '.pdf',
                jsPDF: { format: 'A4', orientation: 'portrait' },
                html2canvas:  { dpi: 300, scale: 8, letterRendering: true, },
            }
            html2pdf().set(opt).from(element).save();
            /*html2pdf().set(opt).from(element).toPdf().get('pdf').then((pdf) => {
                window.open(pdf.output('bloburl'), '_blank');
            });*/
        },
    },
}
</script>

<style scoped>
    .printBtn{position: absolute; top: 64px; right: 16px; z-index: 5}
    .cardContainer{width: 210mm; height: 290mm; padding: 8mm 15mm 4mm 20mm; text-align: center;
        font-family: "Arial"; font-weight: bold; letter-spacing: 0.15px; font-size: 12px }
    .cardContent{width: 100%; height: 100%; position: relative; font-weight: normal; text-align: left}
    .bestHeader{clear: both; font-weight: bold; letter-spacing: 1px; font-size: 16px; text-align: center;
                margin: 48px 0 16px}
    .headerCell{padding-right: 16px}
    .contentCell{padding-right: 10px; line-height: 1.2}
    .vereinsName{ float: left; background-color: mediumblue; padding: 4px 8px; color: white; font-weight: bold}
    .footer {position: absolute; bottom: 0; left: 0; right: 0; }
    .pageHeader {font-size: 16px; font-weight: bold; padding-left: 8px}
</style>